import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  BadgeVariant,
  SHIFT_TYPE_ENUM_RECORD,
  ShiftTypeEnum
} from '@umss/shared/utils';
import { UmssBadgeComponent } from '../badge/badge.component';

/**
 * Component to display a badge based on shift type.
 * Automatically selects the appropriate badge variant, label, and icon based on the shift type.
 */
@Component({
  selector: 'umss-shift-type-badge',
  standalone: true,
  imports: [UmssBadgeComponent],
  template: `
    @if (type && badgeProps) {
      <umss-badge
        [variant]="badgeProps.variant"
        [label]="badgeProps.label"
        [iconName]="badgeProps.iconName"
        [outlined]="badgeProps.outlined"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssShiftTypeBadgeComponent {
  private _type!: ShiftTypeEnum;

  @Input({ required: true }) set type(value: ShiftTypeEnum) {
    this._type = value;
    this.badgeProps = SHIFT_TYPE_BADGE_PROPS[this._type];
  }
  get type(): ShiftTypeEnum {
    return this._type;
  }

  badgeProps: ShiftTypeBadgeProps | undefined;
}

type ShiftTypeBadgeProps = {
  label: string;
  iconName?: string;
  variant: BadgeVariant;
  outlined: boolean;
};

export const SHIFT_TYPE_BADGE_PROPS: Record<
  ShiftTypeEnum,
  ShiftTypeBadgeProps
> = {
  [ShiftTypeEnum.Regular]: {
    label: SHIFT_TYPE_ENUM_RECORD[ShiftTypeEnum.Regular],
    variant: 'secondary',
    outlined: true
  },
  [ShiftTypeEnum.OnCall]: {
    label: SHIFT_TYPE_ENUM_RECORD[ShiftTypeEnum.OnCall],
    iconName: 'phosphorPhone',
    variant: 'info',
    outlined: true
  },
  [ShiftTypeEnum.Urgent]: {
    label: SHIFT_TYPE_ENUM_RECORD[ShiftTypeEnum.Urgent],
    iconName: 'phosphorLightning',
    variant: 'error',
    outlined: false
  },
  [ShiftTypeEnum.TemporaryContract]: {
    label: SHIFT_TYPE_ENUM_RECORD[ShiftTypeEnum.TemporaryContract],
    iconName: 'phosphorCalendarCheck',
    variant: 'primary',
    outlined: true
  }
};
